/* Comparison post template (templates/article.comparison.liquid).
   The page body lives inside the theme's Vue root, which rebuilds the DOM after
   load and drops listeners bound to the original nodes. So everything here is
   either a document-level delegated listener or looks elements up when it runs. */
(function () {
  if (window.__cmpxInit) return;
  window.__cmpxInit = true;

  var root = document.documentElement;
  var q = function (sel) { return document.querySelector(sel); };

  /* Jump bar: shown once the hero has scrolled under the fixed header.
     Publishes --cx-hdr (header height) and --cx-stick (header + bar) for
     anchor offsets, the sticky rail and the sticky table header. */
  var ticking = false, active = -1;
  function headerHeight() {
    var h = q('[data-site-header]');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  function update() {
    ticking = false;
    var bar = q('.cmpx .cx-jumpbar'), hero = q('.cmpx .cx-hero');
    if (!bar || !hero) return;
    var hdr = headerHeight();
    root.style.setProperty('--cx-hdr', hdr + 'px');
    root.style.setProperty('--cx-stick', (hdr + bar.offsetHeight) + 'px');
    var past = hero.getBoundingClientRect().bottom <= hdr;
    bar.classList.toggle('is-shown', past);
    bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    var links = [].slice.call(bar.querySelectorAll('.cx-jump a[href^="#"]'));
    links.forEach(function (a) { a.tabIndex = past ? 0 : -1; });
    var probe = hdr + bar.offsetHeight + 40, idx = 0;
    links.forEach(function (a, i) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t && t.getBoundingClientRect().top <= probe) idx = i;
    });
    if (idx !== active || !bar.querySelector('.is-active')) {
      active = idx;
      links.forEach(function (a, i) {
        a.classList.toggle('is-active', i === idx);
        if (i === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      var list = bar.querySelector('.cx-jump'), el = links[idx];
      if (list && el) {
        var l = el.offsetLeft, r = l + el.offsetWidth;
        if (l < list.scrollLeft || r > list.scrollLeft + list.clientWidth) list.scrollTo({ left: l - 24, behavior: 'smooth' });
      }
    }
  }
  function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  setTimeout(schedule, 600);
  setTimeout(schedule, 2000);
  schedule();

  /* One-tap sizes on the rail product. Subscribe mode sends the product's
     selling plan; one-time mode sends none. */
  var toastTimer;
  function card() { return q('.cmpx .ot'); }
  function mode(c) { return c.getAttribute('data-mode') || (c.getAttribute('data-plan') ? 'sub' : 'once'); }
  function paint(c) {
    var m = mode(c);
    [].forEach.call(c.querySelectorAll('.ot-m button'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-m') === m ? 'true' : 'false');
    });
    [].forEach.call(c.querySelectorAll('.ot-sz'), function (b) {
      var p = m === 'sub' ? b.getAttribute('data-sub') : b.getAttribute('data-one');
      var s = b.querySelector('small');
      if (s) s.textContent = p;
      b.setAttribute('aria-label', b.getAttribute('data-t') + ', ' + p + (m === 'sub' ? ', ' + c.getAttribute('data-plan-name') : ', one time'));
    });
  }
  function close(c) { c.classList.remove('open'); var t = c.querySelector('.ot-t'); if (t) t.setAttribute('aria-expanded', 'false'); }
  function toast(c, b, price) {
    var el = q('.cmpx .ot-toast');
    if (!el) return;
    var m = mode(c);
    el.innerHTML = '';
    var h = document.createElement('b'); h.textContent = 'Added to Cart';
    var p = document.createElement('p');
    p.textContent = c.getAttribute('data-name') + ' – ' + b.getAttribute('data-t') + (m === 'sub' ? ', ' + c.getAttribute('data-plan-name') : ', one time') + ' · ' + price;
    var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View Cart';
    el.appendChild(h); el.appendChild(p); el.appendChild(a);
    el.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('on'); }, 4500);
  }
  document.addEventListener('click', function (ev) {
    var c = card();
    if (!c) return;
    var t = ev.target;
    if (!t.closest('.ot')) { close(c); return; }
    var mb = t.closest('.ot-m button');
    if (mb) { c.setAttribute('data-mode', mb.getAttribute('data-m')); paint(c); return; }
    var tog = t.closest('.ot-t');
    if (tog) {
      c.classList.add('open'); tog.setAttribute('aria-expanded', 'true');
      var f = c.querySelector('.ot-sz'); if (f) f.focus({ preventScroll: true });
      return;
    }
    var b = t.closest('.ot-sz');
    if (!b || b.disabled) return;
    var m = mode(c);
    var item = { id: +b.getAttribute('data-id'), quantity: 1 };
    if (m === 'sub' && c.getAttribute('data-plan')) item.selling_plan = +c.getAttribute('data-plan');
    var price = m === 'sub' ? b.getAttribute('data-sub') : b.getAttribute('data-one');
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        b.classList.add('added');
        setTimeout(function () { b.classList.remove('added'); }, 1600);
        toast(c, b, price);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { window.location.href = c.getAttribute('data-url'); })
      .then(function () { b.disabled = false; });
  });
  document.addEventListener('keydown', function (ev) { var c = card(); if (c && ev.key === 'Escape') close(c); });

  /* FAQ: one answer open at a time. details[name] does this natively in
     current browsers; this covers older ones. toggle does not bubble, so it
     is caught on the way down. */
  document.addEventListener('toggle', function (ev) {
    var d = ev.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !d.closest('.cmpx .bp-faq')) return;
    [].forEach.call(d.closest('.bp-faq').querySelectorAll('details[open]'), function (o) { if (o !== d) o.open = false; });
  }, true);
  function initCard() { var c = card(); if (c) paint(c); }
  document.addEventListener('DOMContentLoaded', initCard);
  window.addEventListener('load', initCard);
  setTimeout(initCard, 1500);
  initCard();
})();
